/*
  Subscription Days Resolver

  This script works with the subscription-days-data.liquid snippet
  to manage subscription days metafield data for cart updates.

  The data structure is exposed by the Liquid snippet at page load,
  and this script ensures it's available for cart callbacks.
*/

(function initSubscriptionDaysResolver() {
  // Initialize the data structure if not already present
  window.productSubscriptionDaysData = window.productSubscriptionDaysData || {};
})();
